function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "adversary-behaviour");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Visual-screens-April-May-June-21",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Artboard",
  transform: "translate(-188.000000, -49.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "adversary-behaviour",
  transform: "translate(188.000000, 49.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "0 0 24 0 24 24 0 24"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.2222222,5.77777778 L18.2222222,18.2222222 L5.77777778,18.2222222 L5.77777778,5.77777778 L18.2222222,5.77777778 M18.2222222,4 L5.77777778,4 C4.79111111,4 4,4.8 4,5.77777778 L4,18.2222222 C4,19.2 4.79111111,20 5.77777778,20 L18.2222222,20 C19.2,20 20,19.2 20,18.2222222 L20,5.77777778 C20,4.8 19.2,4 18.2222222,4 Z M12,12 C10.5333333,12 9.33333333,10.8 9.33333333,9.33333333 C9.33333333,7.86666667 10.5333333,6.66666667 12,6.66666667 C13.4666667,6.66666667 14.6666667,7.86666667 14.6666667,9.33333333 C14.6666667,10.8 13.4666667,12 12,12 Z M12,8.44444444 C11.5111111,8.44444444 11.1111111,8.84444444 11.1111111,9.33333333 C11.1111111,9.82222222 11.5111111,10.2222222 12,10.2222222 C12.4888889,10.2222222 12.8888889,9.82222222 12.8888889,9.33333333 C12.8888889,8.84444444 12.4888889,8.44444444 12,8.44444444 Z M17.3333333,17.3333333 L6.66666667,17.3333333 L6.66666667,15.9733333 C6.66666667,13.7511111 10.1955556,12.7911111 12,12.7911111 C13.8044444,12.7911111 17.3333333,13.7511111 17.3333333,15.9733333 L17.3333333,17.3333333 Z M8.72,15.5555556 L15.28,15.5555556 C14.6666667,15.0577778 13.1644444,14.56 12,14.56 C10.8355556,14.56 9.32444444,15.0577778 8.72,15.5555556 L8.72,15.5555556 Z",
  id: "Shape",
  fill: "#18C7B6",
  fillRule: "nonzero"
}))));

var SvgAdversaryBehaviour = function SvgAdversaryBehaviour(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAdversaryBehaviour, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/adversary-behaviour.aa1af96f.svg";
export { ForwardRef as ReactComponent };